import React from 'react';
import { useData } from '../contexts/DataContext';
import Loading from '../components/Loading';
import './Services.css';

const Services = () => {
  const { services, loading } = useData();

  // Function to get SVG icon based on service icon name
  const getServiceIcon = (iconName) => {
    const icons = {
      home: (
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"></path>
          <polyline points="9 22 9 12 15 12 15 22"></polyline>
        </svg>
      ),
      pencil: (
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <polygon points="12 2 2 7 12 12 22 7 12 2"></polygon>
          <polyline points="2 12 12 17 22 12"></polyline>
          <polyline points="2 17 12 22 22 17"></polyline>
        </svg>
      ),
      sun: (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 50 50" fill="currentColor">
          <path d="M 24.984375 3.9863281 A 1.0001 1.0001 0 0 0 24 5 L 24 11 A 1.0001 1.0001 0 1 0 26 11 L 26 5 A 1.0001 1.0001 0 0 0 24.984375 3.9863281 z M 10.888672 9.890625 A 1.0001 1.0001 0 0 0 10.193359 11.607422 L 14.392578 15.806641 A 1.0001 1.0001 0 1 0 15.806641 14.392578 L 11.607422 10.193359 A 1.0001 1.0001 0 0 0 10.888672 9.890625 z M 39.080078 9.890625 A 1.0001 1.0001 0 0 0 38.392578 10.193359 L 34.193359 14.392578 A 1.0001 1.0001 0 1 0 35.607422 15.806641 L 39.806641 11.607422 A 1.0001 1.0001 0 0 0 39.080078 9.890625 z M 25 15 A 1.0001 1.0001 0 0 0 24.591797 15.082031 C 19.260044 15.307579 15 19.611572 15 25 C 15 30.533333 19.466667 35 25 35 C 30.533333 35 35 30.533333 35 25 C 35 19.612238 30.740979 15.308576 25.410156 15.082031 A 1.0001 1.0001 0 0 0 25 15 z M 5 24 A 1.0001 1.0001 0 1 0 5 26 L 11 26 A 1.0001 1.0001 0 1 0 11 24 L 5 24 z M 39 24 A 1.0001 1.0001 0 1 0 39 26 L 45 26 A 1.0001 1.0001 0 1 0 45 24 L 39 24 z M 15.080078 33.890625 A 1.0001 1.0001 0 0 0 14.392578 34.193359 L 10.193359 38.392578 A 1.0001 1.0001 0 1 0 11.607422 39.806641 L 15.806641 35.607422 A 1.0001 1.0001 0 0 0 15.080078 33.890625 z M 34.888672 33.890625 A 1.0001 1.0001 0 0 0 34.193359 35.607422 L 38.392578 39.806641 A 1.0001 1.0001 0 1 0 39.806641 38.392578 L 35.607422 34.193359 A 1.0001 1.0001 0 0 0 34.888672 33.890625 z M 24.984375 37.986328 A 1.0001 1.0001 0 0 0 24 39 L 24 45 A 1.0001 1.0001 0 1 0 26 45 L 26 39 A 1.0001 1.0001 0 0 0 24.984375 37.986328 z"></path>
        </svg>
      ),
      tools: (
        <svg viewBox="0 0 32 32" fill="none" stroke="currentColor" strokeWidth="2" strokeMiterlimit="10" xmlns="http://www.w3.org/2000/svg">
          <polygon points="25,28 7,28 7,4 19,4 25,10" />
          <polyline points="19,4 19,10 25,10" />
          <rect x="11" y="21" width="10" height="2" />
          <rect x="11" y="17" width="10" height="2" />
          <rect x="11" y="13" width="10" height="2" />
        </svg>
      ),
      layers: (
        <svg viewBox="0 0 32 32" fill="none" stroke="currentColor" strokeWidth="2" strokeLinejoin="round" strokeMiterlimit="10" xmlns="http://www.w3.org/2000/svg">
          <path d="M11,7H5C3.9,7,3,6.1,3,5V3h10v2C13,6.1,12.1,7,11,7z" strokeLinecap="round" />
          <path d="M18,13v6c0,0.6-0.4,1-1,1h-2c-0.6,0-1-0.4-1-1v-6c0-0.6,0.4-1,1-1h2C17.6,12,18,12.4,18,13z" strokeLinecap="round" />
          <path d="M29,29H19v-2c0-1.1,0.9-2,2-2h6c1.1,0,2,0.9,2,2V29z" strokeLinecap="round" />
          <path d="M14,13h-1.8c-0.6,0-1.2-0.5-1.2-1.2V7H5v6v0c0,3.3,2.7,6,6,6h0h3" strokeLinecap="round" />
          <path d="M18,19h1.8c0.6,0,1.2,0.5,1.2,1.2V25h6v-6v0c0-3.3-2.7-6-6-6h-3" strokeLinecap="round" />
        </svg>
      ),
      compass: (
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <circle cx="12" cy="12" r="10"></circle>
          <polygon points="16.24 7.76 14.12 14.12 7.76 16.24 9.88 9.88 16.24 7.76"></polygon>
        </svg>
      ),
    };
    return icons[iconName] || icons.home;
  };

  if (loading) {
    return <Loading />;
  }

  return (
    <div className="services-page">
      <section className="page-header">
        <div className="container">
          <h1>Serviciile Noastre</h1>
          <p>De la dorința de cumpărare a terenului până la finalizarea casei și mobilarea acesteia</p>
        </div>
      </section>

      <section className="section">
        <div className="container">
          {services.length > 0 ? (
            <div className="services-list">
              {services.map((service) => (
                <div key={service.id} className="service-item">
                  <div className="service-content">
                    <h2>
                      <div className="service-icon">
                        {getServiceIcon(service.icon)}
                      </div>
                      {service.title}
                    </h2>
                    <p className="short-desc">{service.short_description}</p>
                    <p className="full-desc">{service.description}</p>
                    
                    {service.features && service.features.length > 0 && (
                      <div className="features">
                        <h3>Caracteristici:</h3>
                        <ul>
                          {service.features.map(feature => (
                            <li key={feature.id}>{feature.feature}</li>
                          ))}
                        </ul>
                      </div>
                    )}

                    {service.important_note && (
                      <div className="important-note">
                        <h3>Mențiune importantă:</h3>
                        <p>{service.important_note}</p>
                      </div>
                    )}
                  </div>
                </div>
              ))}
            </div>
          ) : (
            <p className="no-data">Informații despre servicii în curând.</p>
          )}
        </div>
      </section>

      <section className="cta-section">
        <div className="container">
          <h2>Ne perfecționăm constant</h2>
          <p>Ca să răspundem celor mai sofisticate dorințe!</p>
          <a href="/contact" className="btn">Solicită o Consultație</a>
        </div>
      </section>
    </div>
  );
};

export default Services;

